import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const doctoralCommitteeMembershipApi = generateNomenApi(`/doctoral-committee/doctoral-committee-membership`);

export const doctoralCommitteeMembershipOptions = generateNomenOptions(
  'doctoralCommittee-membership',
  doctoralCommitteeMembershipApi,
);
